export { useDashboard, useSharedDashboard } from './queries';
export { dashboardOptions } from './dashboard.options';
export {
  useUpdateDashboard,
  useDeleteDashboard,
  useSaveDashboard,
  useGenerateShareLink,
  useSendShareEmail,
  SAVE_SNACKBAR_KEY,
  buildDashboardPath,
  buildMergedPayload,
  createHomepageOption,
  getEffectiveTabName,
  homepageMatchesDashboard,
  isFullDashboardStructure,
  isRenameOperation,
  waitForApiSync
} from './mutations';
export type { BulkUpdateMeta, DashboardUpdateInput } from './mutations';
export type { MarketApps } from './queries';
export { dashboardQueryKeys } from '@/features/Dashboard/api/utils';
